export function cleanString(html) {
    const limit = 200;
    if (!html) return "";

    // Parse l'HTML
    const wrapper = document.createElement("div");
    wrapper.innerHTML = html;

    // Helper pour décoder les entités HTML et normaliser les espaces
    const decode = (s) => {
        const ta = document.createElement("textarea");
        ta.innerHTML = s ?? "";
        return (ta.value || "").replace(/\u00a0/g, " "); // remplace &nbsp;
    };

    // 1) Essaye de récupérer le premier <strong>
    const strong = wrapper.querySelector("strong");
    const strongText = strong?.textContent?.trim();
    if (strongText) {
        return decode(strongText).replace(/\s+/g, " ").trim();
    }

    // 2) Sinon, prends tout le texte, nettoie et tronque
    const fullText = decode(wrapper.textContent || wrapper.innerText || "")
        .replace(/\s+/g, " ")
        .trim();

    if (fullText.length > limit) {
        return fullText.slice(0, limit).trimEnd() + "...";
    }
    return fullText;
}